module.exports = __webpack_public_path__ + "static/media/(H)-07-Capim-Dourado-bijuterias.ee19056b.jpg";